import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import {useLocale} from "@components/Contexts/LocaleContext"
import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Separator from "@components/CustomTypography/Separator/Separator"
import ButtonComponent from "@components/Theme/Button/Button"
import ButtonContainer from "@components/WebsiteRevamp/ButtonContainer/ButtonContainer"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {translate} from "@helpers/translate"
import {AdvancedSideAssetModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./HomeBannerOneFree.module.scss"

type Props = {
	data: AdvancedSideAssetModuleType
}

const HomeBannerOneFree = ({data}: Props) => {
	const {locale} = useLocale()

	const content = data.mainContent?.[0]
	if (!content) return null

	const imageAlt = "Dream Broker #One free"
	const imageLink = content.buttons?.[0]?.link ?? "#"
	const ctaLabel = content.buttons?.[0]?.text ?? "Learn More"

	return (
		<>
			<Separator size={128} />
			<ContainerWrapper>
				<div className={styles.bannerWrapper}>
					{/* Desktop Image */}
					<NewResponsiveImage
						{...content.preview}
						src={content.preview ?? ""}
						alt={imageAlt}
						imageClassName={styles.imageClassName}
					/>

					{/* Mobile Image */}
					<NewResponsiveImage
						{...content.inside}
						src={content.inside ?? ""}
						alt={imageAlt}
						imageClassName={styles.imageClassNameMobile}
					/>

					<div className={styles.textOverlay}>
						<NewResponsiveImage
							src={"/dreamBroker/Product-Logo-7.svg"}
							alt={"Logo"}
							containerClassName={styles.logo}
						/>
						<div className={styles.overlayText}>
							<Typography
								content={content.title}
								variant={Variant.SectionTitle}
								className={styles.title}
								contrast
								size={Size.XXXL}
							/>
							<ButtonContainer>
								<ButtonComponent
									link={imageLink}
									asLink
									className={styles.buttonClasses}
								>
									{translate(ctaLabel, locale)}
								</ButtonComponent>
							</ButtonContainer>
						</div>
					</div>
				</div>
			</ContainerWrapper>
		</>
	)
}

export default HomeBannerOneFree
